<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-s-shop"></i> {{ isEdit ? '编辑采购商' : '新增采购商' }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <el-form
        :model="form"
        :rules="rules"
        ref="formRef"
        label-width="120px"
        label-position="right"
        size="small"
      >
        <!-- 基本信息区域 -->
        <div class="form-section">
          <div class="section-title">
            <i class="el-icon-info"></i>
            <span>基本信息</span>
          </div>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="采购商名称" prop="name">
                <el-input 
                  v-model="form.name" 
                  placeholder="请输入采购商名称"
                  prefix-icon="el-icon-s-shop"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="采购商编码" prop="sn">
                <el-input 
                  v-model="form.sn" 
                  placeholder="请输入采购商编码"
                  prefix-icon="el-icon-document"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="经营类型" prop="location_type">
                <el-select v-model="form.location_type" placeholder="请选择经营类型" style="width: 100%;">
                  <el-option label="境内采购" :value="1">
                    <span style="color: #00b578;">● 境内采购</span>
                  </el-option>
                  <el-option label="境外采购" :value="2">
                    <span style="color: #1677ff;">● 境外采购</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="联系人" prop="cont_name">
                <el-input 
                  v-model="form.cont_name" 
                  placeholder="请输入联系人"
                  prefix-icon="el-icon-user"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系电话" prop="mobile">
                <el-input 
                  v-model="form.mobile" 
                  placeholder="请输入联系电话"
                  prefix-icon="el-icon-phone"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="电子邮箱" prop="email">
                <el-input 
                  v-model="form.email" 
                  placeholder="请输入电子邮箱"
                  prefix-icon="el-icon-message"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="企业法人" prop="artiperson">
                <el-input 
                  v-model="form.artiperson" 
                  placeholder="请输入企业法人"
                  prefix-icon="el-icon-user-solid"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="入驻时间" prop="join_time">
                <el-date-picker 
                  v-model="form.join_time" 
                  type="date" 
                  placeholder="选择入驻时间"
                  value-format="timestamp"
                  prefix-icon="el-icon-date"
                  clearable
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="状态" prop="status">
                <el-select v-model="form.status" placeholder="请选择状态" style="width: 100%;">
                  <el-option label="启用" :value="1">
                    <span style="color: #00b578;">● 启用</span>
                  </el-option>
                  <el-option label="禁用" :value="0">
                    <span style="color: #ff4d4f;">● 禁用</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="采购商Logo" prop="logo">
                <div class="logo-upload" @click="uploadLogo">
                  <img v-if="form.logo" :src="form.logo" class="logo-preview" />
                  <i v-else class="el-icon-plus logo-placeholder"></i>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="店铺图片" prop="shop_img">
                <div class="logo-upload" @click="uploadShopImg">
                  <img v-if="form.shop_img" :src="form.shop_img" class="logo-preview" />
                  <i v-else class="el-icon-plus logo-placeholder"></i>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 地区信息区域 -->
        <div class="form-section">
          <div class="section-title">
            <i class="el-icon-location"></i>
            <span>地区信息</span>
          </div>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="所属省份" prop="province">
                <el-select 
                  v-model="form.province" 
                  placeholder="请选择省份"
                  filterable
                  clearable
                  style="width: 100%;"
                  @change="handleProvinceChange"
                >
                  <el-option 
                    v-for="item in provinceList" 
                    :key="item.id" 
                    :label="item.name" 
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所属城市" prop="city">
                <el-select 
                  v-model="form.city" 
                  placeholder="请选择城市"
                  filterable
                  clearable
                  style="width: 100%;"
                  @change="handleCityChange"
                >
                  <el-option 
                    v-for="item in cityList" 
                    :key="item.id" 
                    :label="item.name" 
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所属区县" prop="district">
                <el-select 
                  v-model="form.district" 
                  placeholder="请选择区县"
                  filterable
                  clearable
                  style="width: 100%;"
                >
                  <el-option 
                    v-for="item in districtList" 
                    :key="item.id" 
                    :label="item.name" 
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item label="详细地址" prop="address">
                <el-input 
                  v-model="form.address" 
                  placeholder="请输入详细地址"
                  prefix-icon="el-icon-location"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="经度坐标" prop="lng">
                <el-input 
                  v-model="form.lng" 
                  placeholder="请输入经度，如：120.155070"
                  prefix-icon="el-icon-map-location"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="纬度坐标" prop="lat">
                <el-input 
                  v-model="form.lat" 
                  placeholder="请输入纬度，如：30.274084"
                  prefix-icon="el-icon-map-location"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 社交账号区域 -->
        <div class="form-section">
          <div class="section-title">
            <i class="el-icon-share"></i>
            <span>社交账号</span>
          </div>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="WhatsApp" prop="whatsapp">
                <el-input 
                  v-model="form.whatsapp" 
                  placeholder="请输入WhatsApp账号"
                  prefix-icon="el-icon-chat-dot-round"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Facebook" prop="facebook">
                <el-input 
                  v-model="form.facebook" 
                  placeholder="请输入Facebook账号"
                  prefix-icon="el-icon-share"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="TikTok" prop="ticktok">
                <el-input 
                  v-model="form.ticktok" 
                  placeholder="请输入TikTok账号"
                  prefix-icon="el-icon-video-camera"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="Twitter" prop="twitter">
                <el-input 
                  v-model="form.twitter" 
                  placeholder="请输入Twitter账号"
                  prefix-icon="el-icon-chat-square"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="官方网站" prop="website">
                <el-input 
                  v-model="form.website" 
                  placeholder="请输入官方网站地址"
                  prefix-icon="el-icon-link"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="form.location_type == 2">
              <el-form-item label="所在国家" prop="nation">
                <el-input 
                  v-model="form.nation" 
                  placeholder="请输入国家名称"
                  prefix-icon="el-icon-location-information"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 企业信息区域 -->
        <div class="form-section">
          <div class="section-title">
            <i class="el-icon-office-building"></i>
            <span>企业信息</span>
          </div>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="企业简介" prop="mini_description">
                <el-input 
                  type="textarea"
                  :rows="3"
                  v-model="form.mini_description" 
                  placeholder="请输入企业简介"
                  maxlength="200"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="主营业务" prop="remark">
                <el-input 
                  type="textarea"
                  :rows="3"
                  v-model="form.remark" 
                  placeholder="请输入主营业务"
                  maxlength="200"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="服务项目" prop="service">
                <el-input 
                  type="textarea"
                  :rows="2"
                  v-model="form.service" 
                  placeholder="请输入服务项目"
                  maxlength="500"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="企业详细介绍" prop="description">
                <div class="editor-wrapper">
                  <Toolbar
                    style="border-bottom: 1px solid #e4e7ed"
                    :editor="editor"
                    :defaultConfig="toolbarConfig"
                    :mode="mode"
                  />
                  <Editor
                    style="height: 350px; overflow-y: auto;"
                    v-model="form.description"
                    :defaultConfig="editorConfig"
                    :mode="mode"
                    @onCreated="onCreated"
                  />
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 银行账户区域 -->
        <div class="form-section">
          <div class="section-title">
            <i class="el-icon-bank-card"></i>
            <span>银行账户</span>
          </div>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="开户银行" prop="bank_name">
                <el-input 
                  v-model="form.bank_name" 
                  placeholder="请输入开户银行名称"
                  prefix-icon="el-icon-bank-card"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="银行账号" prop="bank_account">
                <el-input 
                  v-model="form.bank_account" 
                  placeholder="请输入银行账号"
                  prefix-icon="el-icon-credit-card"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 其他信息区域 -->
        <div class="form-section">
          <div class="section-title">
            <i class="el-icon-more"></i>
            <span>其他信息</span>
          </div>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="排序" prop="sort">
                <el-input-number 
                  v-model="form.sort" 
                  :min="0" 
                  :max="999"
                  controls-position="right"
                  style="width: 100%;"
                ></el-input-number>
                <div class="form-tip"><i class="el-icon-info"></i> 数字越小越靠前</div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="营业执照负责人" prop="artiperson">
                <el-input 
                  v-model="form.artiperson" 
                  placeholder="请输入营业执照负责人"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="行业类型" prop="btype">
                <el-select v-model="form.btype" placeholder="请选择行业类型" style="width: 100%;" clearable>
                  <el-option label="零售业" :value="1"></el-option>
                  <el-option label="批发业" :value="2"></el-option>
                  <el-option label="制造业" :value="3"></el-option>
                  <el-option label="服务业" :value="4"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="备注" prop="remark">
                <el-input 
                  type="textarea"
                  :rows="2"
                  v-model="form.remark" 
                  placeholder="请输入备注信息"
                  maxlength="500"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 底部按钮 -->
        <div class="form-actions">
          <el-button type="primary" @click="submitForm" icon="el-icon-check" size="medium">保存</el-button>
          <el-button @click="goBack" icon="el-icon-back" size="medium">返回</el-button>
        </div>
      </el-form>
    </el-card>

    <!-- 图片选择弹框 -->
    <eDocList 
      :formData="imageFormData"
      :visible.sync="imageDialogVisible"
      :title="imageDialogTitle"
      :closeForm="closeImageDialog"
    />
  </div>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
// import moment from 'moment'
import eDocList from '../common/eDocList.vue'

export default {
  name: "purchaserForm",
  components: { Editor, Toolbar, eDocList },
  data() {
    return {
      // 图片上传相关
      imageDialogVisible: false,
      imageDialogTitle: '',
      imageFormData: { source: 'purchaser' },
      uploadType: '',
      
      // 地区数据
      provinceList: [],
      cityList: [],
      districtList: [],
      
      // 表单数据
      form: {
        id: '',
        name: '',
        sn: '',
        cont_name: '',
        mobile: '',
        email: '',
        artiperson: '',
        join_time: '',
        status: 1,
        location_type: 1,
        province: '',
        city: '',
        district: '',
        address: '',
        lng: '',
        lat: '',
        whatsapp: '',
        facebook: '',
        ticktok: '',
        twitter: '',
        website: '',
        nation: '',
        mini_description: '',
        remark: '',
        service: '',
        description: '',
        bank_name: '',
        bank_account: '',
        logo: '',
        shop_img: '',
        sort: 0,
        btype: null,
        proxy_id: sessionStorage.getItem('proxy_id'),
        company_id: sessionStorage.getItem('company_id')
      },
      
      // 富文本编辑器
      editor: null,
      toolbarConfig: {},
      editorConfig: {
        placeholder: '请输入企业详细介绍...',
        MENU_CONF: {
          uploadImage: {
            customUpload: this.uploadEditorImage
          }
        }
      },
      mode: 'default',
      
      // 验证规则
      rules: {
        name: [
          { required: true, message: '请输入采购商名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        cont_name: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        mobile: [
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        location_type: [
          { required: true, message: '请选择经营类型', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    isEdit() {
      return this.form.id && this.form.id > 0
    }
  },
  mounted() {
    this.loadProvinceList()
    const id = this.$route.query.id
    if (id && !isNaN(id) && id > 0) {
      this.form.id = id
      this.getOne()
    }
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy()
    }
  },
  methods: {
    // 加载省份列表
    loadProvinceList() {
      const param = {
        parent_id: 1,
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id')
      }
      this.$axios.regionList(param).then(res => {
        if (res.code == 200) {
          this.provinceList = res.data || []
        }
      }).catch(error => console.log(error))
    },
    
    // 省份变化加载城市
    handleProvinceChange(val) {
      this.form.city = ''
      this.form.district = ''
      const province = this.provinceList.find(p => p.name === val)
      if (province) {
        const param = {
          parent_id: province.id,
          access_token: sessionStorage.getItem('token'),
          company_id: sessionStorage.getItem('company_id')
        }
        this.$axios.regionList(param).then(res => {
          if (res.code == 200) {
            this.cityList = res.data || []
          }
        })
      }
    },
    
    // 城市变化加载区县
    handleCityChange(val) {
      this.form.district = ''
      const city = this.cityList.find(c => c.name === val)
      if (city) {
        const param = {
          parent_id: city.id,
          access_token: sessionStorage.getItem('token'),
          company_id: sessionStorage.getItem('company_id')
        }
        this.$axios.regionList(param).then(res => {
          if (res.code == 200) {
            this.districtList = res.data || []
          }
        })
      }
    },
    
    // 获取采购商详情
    getOne() {
      const param = {
        id: this.form.id,
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id')
      }
      this.$axios.purchaserOne(param).then(res => {
        if (res.code == 200) {
          this.form = { ...this.form, ...res.data }
          if (this.form.province) this.handleProvinceChange(this.form.province)
          if (this.form.city) this.handleCityChange(this.form.city)
        }
      }).catch(error => {
        console.error('获取详情失败:', error)
        this.$message.error('获取详情失败')
      })
    },
    
    // 上传Logo
    uploadLogo() {
      this.uploadType = 'logo'
      this.imageDialogTitle = '选择Logo图片'
      this.imageFormData = { source: 'purchaser' }
      this.imageDialogVisible = true
    },
    
    // 上传店铺图片
    uploadShopImg() {
      this.uploadType = 'shop_img'
      this.imageDialogTitle = '选择店铺图片'
      this.imageFormData = { source: 'purchaser' }
      this.imageDialogVisible = true
    },
    
    // 关闭图片弹框
    closeImageDialog() {
      this.imageDialogVisible = false
    },
    
    // 图片选择回调
    handleImageChoose(id, name, url) {
      if (this.uploadType === 'logo') {
        this.form.logo = url
      } else if (this.uploadType === 'shop_img') {
        this.form.shop_img = url
      }
      this.imageDialogVisible = false
    },
    
    // 富文本编辑器图片上传
    async uploadEditorImage(file, insertFn) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('access_token', sessionStorage.getItem('token'))
      formData.append('company_id', sessionStorage.getItem('company_id'))
      
      this.$axios.uploadImage(formData).then(res => {
        if (res.code == 200) {
          insertFn(res.data.url)
        } else {
          this.$message.error('图片上传失败')
        }
      }).catch(error => {
        console.error('上传失败:', error)
        this.$message.error('图片上传失败')
      })
    },
    
    // 提交表单
    submitForm() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          const api = this.isEdit ? this.$axios.purchaserUpdate : this.$axios.purchaserSave
          api(this.form).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg)
              setTimeout(() => {
                this.$router.push('/purchaserList')
              }, 1500)
            } else {
              this.$message.error(res.msg)
            }
          }).catch(error => {
            console.error('保存失败:', error)
            this.$message.error('保存失败')
          })
        }
      })
    },
    
    // 返回列表
    goBack() {
      this.$router.push('/purchaserList')
    },
    
    onCreated(editor) {
      this.editor = Object.seal(editor)
    }
  }
}
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.breadcrumb-wrapper {
  margin-bottom: 16px;
  .el-breadcrumb { font-size: 14px; i { margin-right: 4px; } }
}

.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  &:hover { box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08); }
  .el-card__body { padding: 20px 24px; }
}

// 表单区块样式
.form-section {
  margin-bottom: 28px;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 20px;
  
  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
  
  .section-title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 20px;
    padding-left: 8px;
    border-left: 3px solid #1677ff;
    
    i { font-size: 16px; color: #1677ff; }
    span { font-size: 15px; font-weight: 600; color: #1f2d3d; }
  }
}

// 表单项样式
.el-form-item { margin-bottom: 20px; }
.el-form-item .el-form-item__label { font-weight: 500; color: #1f2d3d; }

.el-input .el-input__inner,
.el-textarea .el-textarea__inner,
.el-select .el-input__inner,
.el-cascader .el-input__inner {
  border-radius: 8px;
  border-color: #e4e7ed;
  transition: all 0.2s;
  &:focus {
    border-color: #1677ff;
    box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1);
  }
}

// 图片上传样式
.logo-upload {
  width: 120px;
  height: 120px;
  border: 2px dashed #e4e7ed;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #f8f9fc;
  overflow: hidden;
  
  &:hover {
    border-color: #1677ff;
    background: #f0f7ff;
  }
  
  .logo-preview {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .logo-placeholder {
    font-size: 40px;
    color: #c0c4cc;
  }
}

// 富文本编辑器样式
.editor-wrapper {
  border: 1px solid #e4e7ed;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.2s;
  &:focus-within {
    border-color: #1677ff;
    box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1);
  }
}

// 底部按钮样式
.form-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 32px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
  
  .el-button {
    border-radius: 24px;
    padding: 10px 28px;
  }
  .el-button--primary {
    background: #1677ff;
    border-color: #1677ff;
    &:hover { background: #4096ff; border-color: #4096ff; }
  }
}

.form-tip {
  margin-top: 6px;
  font-size: 12px;
  color: #8c8f98;
  i { margin-right: 4px; color: #1677ff; }
}
</style>